import { UiState } from '../managers/UIManager'

type Tab = UiState['activeTab']

interface Props {
  activeTab: Tab
  onTabChange: (tab: Tab) => void
}
const HomeIcon = () => (
  <svg
    width="27"
    height="27"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 20H7C5.89543 20 5 19.1046 5 18V10.9199C5 10.336 5.25513 9.78132 5.69842 9.40136L10.6984 5.11564C11.4474 4.47366 12.5526 4.47366 13.3016 5.11564L18.3016 9.40136C18.7449 9.78132 19 10.336 19 10.9199V18C19 19.1046 18.1046 20 17 20H15M9 20V14C9 13.4477 9.44772 13 10 13H14C14.5523 13 15 13.4477 15 14V20M9 20H15"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
)

const ExploreIcon = () => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width="26" 
    height="26" 
    viewBox="0 0 24 24" 
    fill="none"
    >
      <path 
      d="M15.7955 15.8111L21 21M18 10.5C18 14.6421 14.6421 18 10.5 18C6.35786 18 3 14.6421 3 10.5C3 6.35786 6.35786 3 10.5 3C14.6421 3 18 6.35786 18 10.5Z" 
      stroke="currentColor" 
      stroke-width="2" 
      stroke-linecap="round" 
      stroke-linejoin="round"
      />
  </svg>
)

const ScanIcon = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
    <circle cx="12" cy="13" r="4" />
  </svg>
)

const ShopIcon = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      d="M8 7V6a4 4 0 1 1 8 0v1h3c.552 0 1 .449 1 1.007v12.001c0 1.1-.895 1.992-1.994 1.992H5.994A1.994 1.994 0 0 1 4 20.008v-12C4 7.45 4.445 7 5 7zm1.2 0h5.6V6a2.8 2.8 0 0 0-5.6 0zM8 8.2H5.2v11.808c0 .436.356.792.794.792h12.012a.794.794 0 0 0 .794-.792V8.2H16V11h-1.2V8.2H9.2V11H8z"
    />
  </svg>
)
const ProfileIcon = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12,11A5,5,0,1,0,7,6,5.006,5.006,0,0,0,12,11Zm0-8A3,3,0,1,1,9,6,3,3,0,0,1,12,3ZM3,22V18a5.006,5.006,0,0,1,5-5h8a5.006,5.006,0,0,1,5,5v4a1,1,0,0,1-2,0V18a3,3,0,0,0-3-3H8a3,3,0,0,0-3,3v4a1,1,0,0,1-2,0Z" />
  </svg>
)
export default function BottomNav({ activeTab, onTabChange }: Props) {
  const isActive = (tab: Tab) => activeTab === tab

  return (
    <nav className="app-bottom-nav" aria-label="Main navigation">
      <button
        className={`app-nav-item ${isActive('home') ? 'app-nav-active' : ''}`}
        onClick={() => onTabChange('home')}
        aria-label="Home"
      >
        <HomeIcon />
        <span>Home</span>
      </button>

      <button
        className={`app-nav-item ${isActive('explore') ? 'app-nav-active' : ''}`}
        onClick={() => onTabChange('explore')}
        aria-label="Explore"
      >
        <ExploreIcon />
        <span>Explore</span>
      </button>

      {/* Centre scan button — always pink */}
      <button
        className={`app-nav-item app-nav-scan ${isActive('scan') ? 'app-nav-scan-active' : ''}`}
        onClick={() => onTabChange('scan')}
        aria-label="Scan"
      >
        <span className="app-nav-scan-circle">
          <ScanIcon />
        </span>
        <span>Scan</span>
      </button>

      <button
        className={`app-nav-item ${isActive('shop') ? 'app-nav-active' : ''}`}
        onClick={() => onTabChange('shop')}
        aria-label="Shop"
      >
        <ShopIcon />
        <span>Shop</span>
      </button>

      <button
        className={`app-nav-item ${isActive('profile') ? 'app-nav-active' : ''}`}
        onClick={() => onTabChange('profile')}
        aria-label="Profile"
      >
        <ProfileIcon />
        <span>Profile</span>
      </button>
    </nav>
  )
}
